<template>
    <v-dialog v-model="isOpen" persistent width="536px" class="admin-offers-edit">
        <v-card class="admin-offers-edit__card" >
            <v-card-text class="admin-offers-edit__card-title px-0">
                {{isCreate ? "Crear pago: " : "Editar Pago: "}} <br> 
            </v-card-text>
            <v-card-text v-if="isCreate">
                <v-autocomplete
                    label="Selecionar Organización (OBLIGATORIO)"
                    v-model="organization"
                    :items="organizationItems"
                    hide-details
                    dense
                    filled
                    :filter="filterText"
                    return-object
                    :loading="isLoading"
                    :disabled="organizationItems.length < 1"
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                    <template v-slot:item="{item}">
                        <v-label class="admin-offers-edit__card-message-label">
                            ({{item.id}}) {{item.name}} 
                        </v-label>
                    </template>
                    <template v-slot:selection="data">
                        ({{data.item.id}}) {{data.item.name}}
                    </template>
                </v-autocomplete>
                <v-select
                    label="Selecionar Usuario (OBLIGATORIO)"
                    v-model="user"
                    :items="userItems"
                    item-text="email"
                    hide-details
                    :disabled="userItems.length < 1"
                    return-object
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>
                <v-text-field
                    label="Identificador Compra (OBLIGATORIO)"
                    v-model="item.externalId"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-text-field
                    label="Código de descuento"
                    v-model="item.discountCode"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-row align="center" justify="center" >
                    <v-col cols="6">
                        <v-select
                            label="Moneda"
                            v-model="item.currency"
                            :items="itemsCurrency"
                            hide-details
                            dense
                            filled
                        >
                            <template v-slot="{label}">
                                <v-label class="admin-offers-edit__card-message-label">
                                    {{label}}
                                </v-label>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            label="Total"
                            v-model="item.total"
                            hide-details
                            dense
                            filled
                            type="number"
                        >
                            <template v-slot="{label}">
                                <v-label class="admin-offers-edit__card-message-label">
                                    {{label}}
                                </v-label>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-select
                    label="Metodo de pago (OBLIGATORIO)"
                    v-model="item.method"
                    :items="itemsMethod"
                    item-value="value"
                    item-text="desc"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>
                <v-text-field
                    label="Fecha de pago (OBLIGATORIO)"
                    v-model="item.createdAt"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                    type="date"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-select
                    label="Estado del pago (OBLIGATORIO)"
                    v-model="item.status"
                    :items="itemsStatus"
                    item-value="value"
                    item-text="desc"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>
                <v-select
                    label="Código de la bolsa (OBLIGATORIO)"
                    v-model="item.bucketCode"
                    :items="packsDesc"
                    item-text="name"
                    item-value="code"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>
                <v-file-input
                    v-model="file"
                    label="Documento"
                    filled
                    dense
                    hide-details
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-file-input>
                <v-col cols="12" class="mx-auto px-0" >
                    Bolsa id: {{bucket.id}}
                </v-col>
                <v-row align="center" justify="center" >
                    <v-text-field
                        label="Ocupados"
                        v-model="bucket.current"
                        hide-details
                        dense
                        filled
                        type="number"
                        class="mx-auto"
                    >
                        <template v-slot="{label}">
                            <v-label class="admin-offers-edit__card-message-label">
                                {{label}}
                            </v-label>
                        </template>
                    </v-text-field>
                    <v-text-field
                        label="Máximo"
                        v-model="bucket.max"
                        hide-details
                        dense
                        type="number"
                        filled
                        class="mx-auto"
                    >
                        <template v-slot="{label}">
                            <v-label class="admin-offers-edit__card-message-label">
                                {{label}}
                            </v-label>
                        </template>
                    </v-text-field>
                    <v-text-field
                        label="Fecha vencimiento"
                        v-model="bucket.expiredAt"
                        hide-details
                        dense
                        type="date"
                        filled
                        class="mx-auto"
                    >
                        <template v-slot="{label}">
                            <v-label class="admin-offers-edit__card-message-label">
                                {{label}}
                            </v-label>
                        </template>
                    </v-text-field>
                </v-row>
            </v-card-text>
            <v-card-text v-else>
                <v-text-field
                    label="id"
                    v-if="payment && payment.id"
                    :value="item && item.id ? item.id : 'null'"
                    readonly
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-text-field
                    :label="`Usuario (id: ${item && item.user ? item.user.id : 'null'})`"
                    :value="item && item.user ? item.user.email : ''"
                    readonly
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-text-field
                    label="Identificador Compra"
                    v-model="item.externalId"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-text-field
                    label="Código de descuento"
                    v-model="item.discountCode"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-row align="center" justify="center" >
                    <v-col cols="6">
                        <v-select
                            label="Moneda"
                            v-model="item.currency"
                            :items="itemsCurrency"
                            hide-details
                            dense
                            filled
                        >
                            <template v-slot="{label}">
                                <v-label class="admin-offers-edit__card-message-label">
                                    {{label}}
                                </v-label>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            label="Total"
                            v-model="item.total"
                            hide-details
                            dense
                            filled
                            type="number"
                        >
                            <template v-slot="{label}">
                                <v-label class="admin-offers-edit__card-message-label">
                                    {{label}}
                                </v-label>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-select
                    label="Metodo de pago (OBLIGATORIO)"
                    v-model="item.method"
                    :items="itemsMethod"
                    item-value="value"
                    item-text="desc"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>
                <v-text-field
                    label="Fecha de pago"
                    v-model="item.createdAt"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                    type="date"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-select
                    label="Estado del pago"
                    v-model="item.status"
                    :items="itemsStatus"
                    item-value="value"
                    item-text="desc"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>
                <v-select
                    label="Código de la bolsa (OBLIGATORIO)"
                    v-model="item.bucketCode"
                    :items="packsDesc"
                    item-text="name"
                    item-value="code"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>
                <v-file-input
                    v-model="file"
                    label="Documento"
                    filled
                    dense
                    hide-details
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-file-input>
                <v-col cols="12" class="mx-auto px-0" >
                    Bolsa id: {{bucket && bucket.id ? bucket.id : ""}}
                </v-col>
                <v-row align="center" justify="center" >
                    <v-text-field
                        label="Ocupados"
                        v-model="bucket.current"
                        hide-details
                        dense
                        filled
                        type="number"
                        class="mx-auto"
                    >
                        <template v-slot="{label}">
                            <v-label class="admin-offers-edit__card-message-label">
                                {{label}}
                            </v-label>
                        </template>
                    </v-text-field>
                    <v-text-field
                        label="Máximo"
                        v-model="bucket.max"
                        hide-details
                        dense
                        type="number"
                        filled
                        class="mx-auto"
                    >
                        <template v-slot="{label}">
                            <v-label class="admin-offers-edit__card-message-label">
                                {{label}}
                            </v-label>
                        </template>
                    </v-text-field>
                    <v-text-field
                        label="Fecha vencimiento"
                        v-model="bucket.expiredAt"
                        hide-details
                        dense
                        type="date"
                        filled
                        class="mx-auto"
                    >
                        <template v-slot="{label}">
                            <v-label class="admin-offers-edit__card-message-label">
                                {{label}}
                            </v-label>
                        </template>
                    </v-text-field>
                </v-row>
            </v-card-text>
            <v-card-actions class="admin-offers-edit__card d-flex justify-end align-center mx-0 px-0">
                <v-btn
                    @click="closeDialog"
                    outlined
                    color="#3BADFF"
                    dark
                    :disabled="isLoading"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    v-if="!isCreate"
                    :loading="isLoading"
                    @click="updateItem"
                    outlined
                    color="#3BADFF"
                    dark
                    class="px-5"
                >
                    Actualizar
                </v-btn>
                <v-btn
                    v-if="isCreate"
                    :loading="isLoading"
                    @click="createItem"
                    outlined
                    color="#3BADFF"
                    dark
                    class="px-5"
                >
                    Crear
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import { datetime, currentImg, handleTxt } from "@/libs/mixins";
import { packsDesc } from "@/config/fixtures";
import { mapGetters, mapActions } from "vuex";


export default {
    name: "AdminPaymentForm",
    props: {
        payment: {
            default: null
        },
        dialog: {
            default: false,
            type: Boolean
        },
        isCreate: {
            default: false,
            type: Boolean
        }
    }, 
    mixins: [datetime, currentImg, handleTxt],
    data() {
        return {
            isLoading: false,
            isOpen: false,
            errors: false,
            organization: null,
            organizationItems: [],
            itemsCurrency: ["CLP", "USD"],
            userItems: [],
            search: null,
            file: null,
            itemsStatus: [
                { desc: "Aprobado", value: "approved" },
                { desc: "Pendiente", value: "pending" },
                { desc: "Devuelto", value: "refounded" },
                { desc: "Rechazado", value: "failed" }
            ],
            itemsMethod: [
                { desc: "Mercado Pago", value: "mercadopago" },
                { desc: "Paypal", value: "paypal" },
                { desc: "Código Gratis", value: "free" },
                { desc: "Transferencia", value: "transfer" }
            ],
            item: {
                bucketId: "",
                bucketCode: "",
                discountCode: "",
                document: "",
                externalId: "",
                method: "",
                status: "",
                total: 0,
                currency: "",
                createdAt: ""
            },
            bucket: {
                args: null,
                current: 0,
                max: 0,
                expiredAt: ""
            },
            user: null,
        };
    },
    computed: {
        ...mapGetters("users", ["getRole", "getType"]),
        packsDesc() {
            const packsDescClone = [...packsDesc];
            packsDescClone.push({ name: "Pack 50", code: "B13P50" });
            packsDescClone.push({ name: "Pack Limitado", code: "B02I01" });
            return packsDescClone;
        }
    },
    watch: {
        errors() {
            console.info("errors: ", this.errors);
        },
        dialog() {
            this.isOpen = this.dialog || false;
        },
        "item.total"() {
            this.item.total = parseInt(this.item.total);
        },
        async organization() {
            this.userItems = [];
            this.bucket = {
                args: null,
                current: 0,
                max: 0,
                expiredAt: ""
            };
            const users = await this.getUsersByOrg(this.organization.id);
            console.log(users);
            this.userItems = users;
            users.forEach(u => {
                if (u.organization.bucketId !== null) {
                    this.bucket = { ...u.organization.bucket, expiredAt: this.getDate(u.organization.bucket.expiredAt) };
                }
            });
        },
        async isCreate() {
        },
        async payment() {
            this.isLoading = true;
            if (typeof this.payment === "object" && !this.isCreate) {
                this.item = { ...this.payment, total: parseInt(this.payment.total), createdAt: this.getDate(this.payment.createdAt) };
                this.bucket = { ...this.payment.bucket, expiredAt: this.getDate(this.item.bucket.expiredAt || "") };
                this.user = { ...this.payment.user };
                if (this.item.document && this.item.document !== "") {
                    const data = await fetch(process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_INVOICE_PATH + this.item.document);  
                    this.file = await data.blob();
                    this.file.name = this.item.document;
                } else {
                    this.file = null;
                }
            } else {
                this.getOrganizations({ role: this.getRole }).then(result => {
                    this.organizationItems = result.organizations.flat();
                }).catch(error => {
                    console.log(error);
                }).finally(() => this.isLoading = false);
            }
            this.isLoading = false;
        }
    },
    methods: {
        ...mapActions("organizations", ["getOrganizations"]),
        ...mapActions("users", ["getUsersByOrg"]),
        ...mapActions("accounts", ["updatePayments", "updateBucket", "deletePayment"]),
        ...mapActions("uploads", ["uploadInvoice", "upload", "getPermissions"]),
        getDate(date) {
            if (date === "") {
                return "";
            }
            const [year, month, day] = new Date(date).toISOString().slice(0, 10).split("-");
            return `${year}-${month}-${day}` || "";
        },
        toBase64(file) { 
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        closeDialog() {
            this.isLoading = false;
            this.organizationItems = [];
            this.userItems = [];
            this.file = null;
            this.item = {
                bucketId: "",
                bucketCode: "",
                discountCode: "",
                document: "null",
                externalId: "",
                method: "",
                status: "",
                total: "",
                currency: 0,
                createdAt: ""
            };
            this.bucket = {
                args: null,
                current: 0,
                max: 0,
                expiredAt: ""
            };
            this.organization = null;
            this.user = null;
            this.$emit("close");
        },
        filterText(item, search, value) {
            return  value !== null &&
                search !== null &&
                (this.normalized(item.id).includes(this.normalized(search)) || 
                this.normalized(item.name).includes(this.normalized(search)));
        },
        async createItem() {
            try {
                this.isLoading = true;
                if (this.file) {
                    const form = new FormData();
                    const data = await this.getPermissions({
                        scope: "organization",
                        type: "invoice",
                        resource: {
                            path: `${process.env.VUE_APP_ASSETS_INVOICE_PATH}${this.file.name}`,
                            type: this.file.type
                        }
                    });
                    for (let field in data.presignedPostData.fields) {
                        form.append(field, data.presignedPostData.fields[field]);
                    }
                    form.append("file", this.file);
                    const u = this.upload({ form: form, url: data.presignedPostData.url });
                    this.item.document = this.file.name;
                } else {
                    this.item.document = "";
                }
                const newItem = await this.updatePayments({ ...this.item, bucketId: this.bucket.id, userId: this.user.id, bucket: this.bucket });
                this.$emit("addItem", { ...newItem });
                this.closeDialog();
            } catch (error) {
                console.error(error);
            }
        },
        async updateItem() {
            try {
                this.isLoading = true;
                // let file64 = null;
                if (this.file) {
                    const form = new FormData();
                    const data = await this.getPermissions({
                        scope: "organization",
                        type: "invoice",
                        resource: {
                            path: `${process.env.VUE_APP_ASSETS_INVOICE_PATH}${this.file.name}`,
                            type: this.file.type
                        }
                    });
                    for (let field in data.presignedPostData.fields) {
                        form.append(field, data.presignedPostData.fields[field]);
                    }
                    form.append("file", this.file);
                    const u = this.upload({ form: form, url: data.presignedPostData.url });
                    this.item.document = this.file.name;
                } else {
                    this.item.document = "";
                }
                const updatedItem = await this.updatePayments({ ...this.item, bucketId: this.bucket.id, userId: this.user.id, bucket: this.bucket });
                this.$emit("updateItems", { ...updatedItem });
                this.closeDialog();
            } catch (error) {
                console.error(error);
            }
        },
    }
};
</script>
